import { fromBaseRecord } from './from-base-context';
import type { FromBaseRow as Row } from './from-base-context';
import { readItemField } from './item-field-reader';

function object(value: unknown): Row | null {
    try { if (typeof value === 'string') value = JSON.parse(value); } catch { return null; }
    return fromBaseRecord(value) ? value : null;
}

/** Bind saved creator controls and wardrobe facts to the actor's exact rigged mesh. */
export function withActorAvatarBodies(meshes: Row[], rawMeshes: readonly Row[], actor: unknown, wardrobe: unknown): Row[] {
    if (!fromBaseRecord(actor) || !fromBaseRecord(wardrobe)) return meshes;
    const appearance = object(readItemField(actor, 'appearance'));
    const body = appearance && object(readItemField(appearance, 'body'));
    if (!body || readItemField(body, 'controlContractId') !== 'ft.humanoid.body-controls.v2') return meshes;
    const presentation = readItemField(body, 'presentation'), values = readItemField(body, 'values');
    if (!['masculine', 'feminine'].includes(String(presentation)) || !fromBaseRecord(values)) return meshes;
    return meshes.map(mesh => {
        if (readItemField(mesh, 'variant') !== 'ft3d_avatar') return mesh;
        const raw = rawMeshes.find(row => readItemField(row, 'mesh_id') === readItemField(mesh, 'id'));
        const receipt = raw && object(readItemField(raw, 'mesh_description'));
        if (!receipt || readItemField(receipt, 'schema') !== 'ft.ft3d-avatar-provenance.v1'
            || readItemField(receipt, 'capability') !== 'rigged') return mesh;
        // Raw definition inputs must stay opaque to the compiled catalog's recursive intern pass.
        return { ...mesh, avatarBody: { sha256: readItemField(mesh, 'sha256'), presentation,
            controlContractId: readItemField(body, 'controlContractId'), values, mogInputs: JSON.stringify(wardrobe) } };
    });
}
